import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil"
import { walletSlideUpAtom } from "../stores/wallet"
import { WalletSlideUp } from "./NFT/WalletSlideUp"
import { Utils } from "../utils";

export const Footer = () => {
  const setExpand = useSetRecoilState(walletSlideUpAtom);
  const navigate = useNavigate();

  return (
    <>
      <div className="w-100 p-3 pb-5 bg-slate-700 text-gray-300">
        <div className="container px-3 px-md-5 flex flex-column flex-lg-row align-items-baseline align-items-lg-center gap-x-3">
          <span className="text-white relative mb-2 me-3">
            <WalletSlideUp />
            <span className="cursor-pointer" onClick={() => {
              setExpand(true);
            }}>錢包</span>
          </span>
          <span className="text-white relative mb-2 me-3">
            <span className="cursor-pointer" onClick={() => {
              navigate('/web/asset/my')
            }}>我的NFT</span>
          </span>
          
          <a className="signLine d-flex w-fit mb-2 me-3" href="https://lin.ee/Po9IfkE" target='_blank' rel="noreferrer">
            <div className="line">
              <img src={require("../assets/img/linew.png")} alt="" />
            </div>
            <button id="line-login-btn" className="pl-2 pr-3" style={{ width: 'auto' }}>客服</button>
          </a>


          <span className="text-white relative mb-2 me-3">
            <span className="cursor-pointer" onClick={() => {
              navigate('/web/partner')
            }}>戰略夥伴</span>
          </span>
          <span className="relative mb-2 me-3">
            <a href="/pdf/protocol.pdf" target={'_blank'} className="text-white">使用者條款《隱私權政策》</a>
          </span>
          {
            Utils().isLogin() && <span className="text-white relative">
              <span className="cursor-pointer mb-2 me-3" onClick={() => {
                navigate('/web/login/nft')
              }}>登出</span>
            </span>
          }
          {
            !Utils().isLogin() && <span className="text-white relative">
              <span className="cursor-pointer" onClick={() => {
                navigate('/web/login/nft')
              }}>登入</span>
            </span>
          }
        </div>
      </div>
    </>
  )
}